import React from "react";
import BasicDetails from "./BasicDetails";
import ResetPassword from "./ResetPass";
import AccountOpeningLetter from "./AccountOpeningLetter/AccountOpeningLetter";
import BalanceConfirmationLetter from "./BalanceConfirmationLetter/BalanceConfirmationLetter";
import AccountStatement from "./AccountStatement/AccountStatement";
import ChangePassword from "./ChangePIN";
import { useOverview, useSettings } from "./../../hooks";
import Loader from "./../../Components/Loader/PageLoader";
import { getSession } from "./../../axios.config";
import ProtectedLayout from "./../../Components/Navbar/ProtectedNavbar";
import BackToUnified from "./../../Components/sideBar/backToUnified.js";

function AccountSettings() {
  const { useAccountData, activeTab, setActiveTab } = useSettings();
  const { useGlobalAccount } = useOverview();
  const user = JSON.parse(getSession("userId"));

  const { data: AccountData, isLoading: accountIsLoading } = useAccountData(
    user?.userId,
  );
  const { data: globalData } = useGlobalAccount(true);
  const isApproved = globalData?.data?.status === "APPROVED";

  const nav = {
    className: "border-b border-gray-300",
    "aria-label": "Tabs",
    buttons: [
      {
        text: " Basic details",
        activeTab: "basic-details",
        onClick: () => setActiveTab("basic-details"),
      },
      {
        text: "Reset password",
        activeTab: "Reset-password",
        onClick: () => setActiveTab("Reset-password"),
      },

      ...(isApproved
        ? [
            {
              text: "Account Opening Letter",
              activeTab: "Account-Opening-Letter",
              onClick: () => setActiveTab("Account-Opening-Letter"),
            },
            {
              text: "Balance Confirmation Letter",
              activeTab: "Balance-Confirmation-Letter",
              onClick: () => setActiveTab("Balance-Confirmation-Letter"),
            },
            {
              text: "Account Statement",
              activeTab: "Account-Statement",
              onClick: () => setActiveTab("Account-Statement"),
            },
          ]
        : []),
        // {
        //   text: "Change PIN",
        //   activeTab: "Change-PIN",
        //   onClick: () => setActiveTab("Change-PIN"),
        // },
    ],
  };

  return (
    <ProtectedLayout notVerified={AccountData?.data?.status === "PENDING"}>
      <div className="px-6 md:min-h-[calc(100dvh-108px)] xl:min-h-[calc(100dvh-136px)]  overflow-scroll xl:px-40 mt-[63px]  p-6">
        {accountIsLoading ? (
          <div className="mt-[25px] h-10 w-14">
            <Loader />
          </div>
        ) : (
          <div className="mt-[25px]">
            <h1 className="text-[20px] leading-[28px] font-[500] font-geomanistMedium mb-1">
              {AccountData?.data?.name}
            </h1>
            <p className="text-[16px] leading-[28px] text-greyish">
              {globalData?.data?.vendorAccountNo &&
                `******${globalData?.data?.vendorAccountNo?.slice(-4)} /`}{" "}
              Username: {AccountData?.data?.username}
            </p>
          </div>
        )}

        <div className="border-b mt-[30px] overflow-x-auto">
          <div className="flex min-w-full pb-1 whitespace-nowrap">
            {nav.buttons.map((button, index) => (
              <button
                key={index}
                className={`relative py-4 mr-6 text-blackShade text-[16px] leading-[24px] min-w-fit ${
                  activeTab === button.activeTab
                    ? "text-blueish"
                    : "hover:text-gray-500"
                }`}
                onClick={button.onClick}
              >
                {button.text}
                <span
                  className={`absolute left-0 right-0 bottom-0 h-[3px] mx-2 transition-all duration-300 ${
                    activeTab === button.activeTab
                      ? "bg-blueish"
                      : "bg-transparent"
                  }`}
                />
              </button>
            ))}
          </div>
        </div>

        {activeTab === "basic-details" && <BasicDetails />}

        {activeTab === "Reset-password" && (
          <ResetPassword AccountData={AccountData} />
        )}
        {isApproved && activeTab === "Account-Opening-Letter" && (
          <AccountOpeningLetter globalData={globalData} />
        )}
        {isApproved && activeTab === "Balance-Confirmation-Letter" && (
          <BalanceConfirmationLetter globalData={globalData} />
        )}
        {isApproved && activeTab === "Account-Statement" && (
          <AccountStatement AccountData={AccountData} globalData={globalData} />
        )}
        {activeTab === "Change-PIN" && <ChangePassword />}
      </div>
      <BackToUnified />
    </ProtectedLayout>
  );
}

export default AccountSettings;
